import React from 'react'
import AdminProfile from '../components/AdminProfile'

const Profile = () => {
  return (
    <div>
        <AdminProfile/>
    </div>
  )
}

export default Profile